import Sidebar from "@/components/Sidebar";
import { Outlet } from "react-router-dom";

export default function AppLayout() {
  return (
    <div className="h-full flex bg-[#F4F4F0] text-[#0A0A0A] overflow-hidden">
      <Sidebar />
      <main
        data-testid="app-main"
        className="flex-1 min-w-0 h-full overflow-y-auto overflow-x-hidden"
      >
        <Outlet />
      </main>
    </div>
  );
}
